// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 공통 관리자 breadcrumb 스타일 */
.breadcrumb {
    background-color: #f1f1f1;
    padding: 21px 82px;
    color: #717171;
    font-size: 14px;
}

.breadcrumb span {
    font-size: 14px;
    color: #717171;
}

/* 공통 관리자 메인 컨텐츠 레이아웃 */
.admin-main-content {
    display: flex;
    padding: 20px 40px;
}

.admin-sidebar {
    width: 220px;
    margin-right: 30px;
    flex-shrink: 0;
}

.sidebar-menu {
    margin-bottom: 34px;
}

.sidebar-menu h3 {
    font-size: 18px;
    margin: 0 0 15px 0;
    color: #333;
}

.sidebar-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar-menu ul li {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #717171;
    transition: all 0.2s ease;
}

.sidebar-menu ul li:hover {
    color: #e84118;
    background-color: #f8f8f8;
}

.sidebar-menu ul li.active {
    color: #e84118;
    font-weight: bold;
    background-color: #fff5f3;
    border-left: 3px solid #e84118;
    padding-left: 17px;
}

.admin-content {
    flex-grow: 1;
}

.admin-content h2 {
    font-size: 24px;
    margin-top: 0;
    margin-bottom: 20px;
    border-bottom: 2px solid #e84118;
    padding-bottom: 10px;
    color: #333;
}

/* 페이지 헤더 공통 스타일 */
.page-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.page-title-bar {
    width: 5px;
    height: 24px;
    background-color: #e84118;
}

/* 반응형 디자인 */
@media (max-width: 1024px) {
    .breadcrumb {
        padding: 15px 20px;
    }
    
    .admin-main-content {
        flex-direction: column;
        padding: 15px 20px;
    }
    
    .admin-sidebar {
        width: 100%;
        margin-right: 0;
        margin-bottom: 20px;
    }
}

@media (max-width: 768px) {
    .breadcrumb {
        padding: 10px 15px;
        font-size: 12px;
    }
    
    .admin-main-content {
        padding: 10px 15px;
    }
    
    .sidebar-menu ul li {
        padding: 8px 15px;
        font-size: 13px;
    }
    
    .admin-content h2 {
        font-size: 20px;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/AdminCommon.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;IACpB,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* 공통 관리자 breadcrumb 스타일 */\n.breadcrumb {\n    background-color: #f1f1f1;\n    padding: 21px 82px;\n    color: #717171;\n    font-size: 14px;\n}\n\n.breadcrumb span {\n    font-size: 14px;\n    color: #717171;\n}\n\n/* 공통 관리자 메인 컨텐츠 레이아웃 */\n.admin-main-content {\n    display: flex;\n    padding: 20px 40px;\n}\n\n.admin-sidebar {\n    width: 220px;\n    margin-right: 30px;\n    flex-shrink: 0;\n}\n\n.sidebar-menu {\n    margin-bottom: 34px;\n}\n\n.sidebar-menu h3 {\n    font-size: 18px;\n    margin: 0 0 15px 0;\n    color: #333;\n}\n\n.sidebar-menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sidebar-menu ul li {\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #717171;\n    transition: all 0.2s ease;\n}\n\n.sidebar-menu ul li:hover {\n    color: #e84118;\n    background-color: #f8f8f8;\n}\n\n.sidebar-menu ul li.active {\n    color: #e84118;\n    font-weight: bold;\n    background-color: #fff5f3;\n    border-left: 3px solid #e84118;\n    padding-left: 17px;\n}\n\n.admin-content {\n    flex-grow: 1;\n}\n\n.admin-content h2 {\n    font-size: 24px;\n    margin-top: 0;\n    margin-bottom: 20px;\n    border-bottom: 2px solid #e84118;\n    padding-bottom: 10px;\n    color: #333;\n}\n\n/* 페이지 헤더 공통 스타일 */\n.page-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.page-title-bar {\n    width: 5px;\n    height: 24px;\n    background-color: #e84118;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 1024px) {\n    .breadcrumb {\n        padding: 15px 20px;\n    }\n    \n    .admin-main-content {\n        flex-direction: column;\n        padding: 15px 20px;\n    }\n    \n    .admin-sidebar {\n        width: 100%;\n        margin-right: 0;\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width: 768px) {\n    .breadcrumb {\n        padding: 10px 15px;\n        font-size: 12px;\n    }\n    \n    .admin-main-content {\n        padding: 10px 15px;\n    }\n    \n    .sidebar-menu ul li {\n        padding: 8px 15px;\n        font-size: 13px;\n    }\n    \n    .admin-content h2 {\n        font-size: 20px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
